// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2vpvl","left":"StickyBox_left__U08pk","right":"StickyBox_right__2hUr6"};